import { useQuery } from 'react-query'
import api from '../../services/api';

const fetchEquipmentType = (equipmentTypeId) => api.get(`/equipment-type/${equipmentTypeId}`).then((res) => res.data);

export default function useEquipmentType(equipmentTypeId) {
  return useQuery(['equipmentTypes', equipmentTypeId], () => fetchEquipmentType(equipmentTypeId));
}